export class SearchFilter {
    searchText: string;
    selectedFilters: any;
    groupBy: string;
}
